import React, { Suspense } from 'react'

export default function withRouteSuspense(Component) {
  return props => (
    <Suspense fallback={<div />}>
      <Component {...props} />
    </Suspense>
  )
}
